import { render } from "./breadpay-page.vue?vue&type=template&id=35adc694"
import script from "./breadpay-page.vue?vue&type=script&lang=js"
export * from "./breadpay-page.vue?vue&type=script&lang=js"

import "./breadpay-page.vue?vue&type=style&index=0&id=35adc694&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__